<template>
  <div class="vc-icons-dropdown">

    <v-select v-if="!displayOnly"
              v-model="selectedItem"
              :items="arrayItems"
              :label="listItems.label"
              :rules="rules"
              item-text="type"
              item-value="label"
              return-object
              @change="selectionChanged">

      <template v-slot:selection="data">
          <span class="client-fields-autocomplete-icon"
                :class="data.item.icon_dark"/>
        <span class="client-fields-autocomplete-text">
            {{$t(data.item.label)}}
          </span>
      </template>

      <template v-slot:item="data">
        <v-layout row
                  class="vc-icons-dropdown-options"
                  :class="data.item.class">
          <div :class="data.item.icon_dark"
               class="client-fields-autocomplete-icon"></div>
          <div class="client-fields-autocomplete-item-text">
            {{$t(data.item.label)}}
          </div>
        </v-layout>
      </template>

    </v-select>

    <v-layout column
              class="display-only"
              v-if="displayOnly">
      <div class="field-label">
        {{$t('settings.client_card.field_type')}}
      </div>
      <div>
          <span class="client-fields-autocomplete-icon"
                :class="selected.icon_dark"/>
        <span class="client-fields-autocomplete-text">
            {{selected.selectedValue}}
          </span>
      </div>
    </v-layout>

  </div>
</template>

<script>
  export default {
    name: "VCIconsDropdown",
    props: ['listItems', 'selected', 'displayOnly', 'rules'],
    data() {
      return {
        selectedItem : null,
      }
    },
    computed: {
      arrayItems() {
        const arr = JSON.parse(JSON.stringify(this.listItems.items));

        if (this.listItems.customLastItem) {
          arr.push(this.listItems.customLastItem);
        }

        return arr;
      }
    },
    methods: {
      selectionChanged() {
        this.$emit("selectionChanged", this.selectedItem);
      }
    }
  }
</script>
<style lang="scss" scoped>
  @import "@/assets/scss/abstract/_variables.scss";

  .client-fields-autocomplete-text {
    margin: 0 10px;
    font-size: 14px;
  }

  .client-fields-autocomplete-icon {
    font-size: 16px;
    line-height: 19px;
  }

  .client-fields-autocomplete-item-text {
    margin: 0 10px;
    font-size: 14px;
  }

  .vc-icons-dropdown {
    color: $color_dark_text;

    .field-label {
      color: rgba(0, 0, 0, 0.54);
      height: 20px;
      line-height: 20px;
      font-size: 10px;
      margin-bottom: 5px;
    }

    .v-text-field__details {
      display: none;
    }
  }

  .vc-icons-dropdown-options {
    margin: 0;

    &.add-new {
      color: $addToListColor;

      .icon-plus-s {
        margin-top: 1px;
      }
    }
  }
</style>
